import React from 'react';
import { colorPalette } from '@rakutenfrance/mui';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTranslate } from '@rakutenfrance/tolgee-provider';
export const UnavailableContent = ({ isEshop }) => {
    const { t } = useTranslate('legal-economic-operator');
    return (React.createElement(Box, null,
        React.createElement(Stack, { sx: {
                padding: '16px',
                borderRadius: '8px',
                backgroundColor: colorPalette.gray100,
            } },
            React.createElement(Typography, { color: colorPalette.gray900, fontWeight: '600', "data-ts": "responsible_eu" }, t('responsible_eu', 'Personne responsable dans l’Union européenne (UE) :')),
            React.createElement(Typography, { color: colorPalette.gray900, sx: {
                    marginTop: '8px',
                }, "data-ts": "unavailable_data" }, t('unavailable_data', 'La Personne Responsable dans l’UE ou “Opérateur Economique”, est la personne en charge de nombreux aspects de la conformité et de\
          la sécurité d’un produit sur le marché européen.'))),
        React.createElement(Stack, { sx: {
                marginTop: '16px',
                display: 'block',
            } },
            React.createElement(Typography, { sx: {
                    display: 'inline',
                }, color: colorPalette.gray700, "data-ts": "vendor" }, `${isEshop ? t('vendor', "Ce vendeur n'a pas ") : t('vendors', "Aucun vendeur n'a ")}`),
            React.createElement(Typography, { sx: {
                    display: 'inline',
                }, color: colorPalette.gray700, "data-ts": "transmition_data" }, t('transmition_data', 'encore transmis les coordonnées de son opérateur économique pour ce produit spécifique. Cette information peut être mise à jour à\
          tout moment.')))));
};
